export const etlsService = {
  async executeTransformation (database, files) {
    await axios.post(`admin/etls/execute-transformation`, {
      database,
      files
    })
  },
  async executeJob (database, files) {
    await axios.post(`admin/etls/execute-job`, {
      database,
      files
    })
  },
  async checkServerStatus () {
    await axios.get(`admin/etls/server-status`)
  }
}
